import spartaStoreUtility from "global/sparta-store-utility";
import _ from "vendor/lodash";
import spartaEventsUtility from "global/sparta-events-utility";
import spartaMediaQueryConstantsUtility from "global/sparta-mediaquery-constants-utility";





const getPrefixedPixelRatio = () => {

  const elem = document.createElement('sparta');


  const prefixes = {
    webkitTransform: '-webkit-min-device-pixel-ratio: 2',
    MozTransform: 'min--moz-device-pixel-ratio: 2',
    oTransform: '-o-min-device-pixel-ratio: 2/1',
  };


  let result = 'min-device-pixel-ratio: 2';


  Object.keys(prefixes).some(prefix => {

    if (elem.style[prefix] !== undefined) {

      result = prefixes[prefix];


      return true;
    }

    return false;
  });


  return result;
};

export {
  getPrefixedPixelRatio,
};
